/**
 * Country configuration for supported countries
 * Uses ISO 3166-1 alpha-2 country codes
 */
const COUNTRY_CONFIG: Record<string, { name: string; flag: string }> = {
  VN: { name: 'Vietnam', flag: '🇻🇳' },
  US: { name: 'United States', flag: '🇺🇸' },
}

/**
 * List of supported country codes for use in dropdowns
 */
export const SUPPORTED_COUNTRIES: string[] = Object.keys(COUNTRY_CONFIG)

/**
 * Get human-readable name for a country code
 */
export function getCountryName(country: string): string {
  return COUNTRY_CONFIG[country]?.name || country
}

/**
 * Get the flag emoji for a country code
 */
export function getCountryFlag(country: string): string {
  return COUNTRY_CONFIG[country]?.flag || '🏳️'
}

/**
 * Get the full country configuration
 */
export function getCountryConfig(country: string) {
  return COUNTRY_CONFIG[country] || { name: country, flag: '🏳️' }
}
